export enum WorkshopEndpoints {
  SUMMARY = "/workshop",
  ABOUT = "/workshop/test/about",
  SESSIONS = "workshop/test/sessions",
  PRACTITIONERS = "workshop/test/practitioners",
  CART = "/workshop/addToCart",
  CANCEL_BOOKING = "/workshop/cancel",
}
